module.exports = __webpack_public_path__ + "static/media/emailIcon.7b972ad2.svg";